import React from 'react';
import { MedicationRequestOutputDto } from 'graphql/generated/remote-schema-hasura';
import MedicationHeader from './MedicationHeader';
import MedicationRow from './MedicationRow';
import MedicationMobile from './MedicationMobile';
import { twMerge } from 'tailwind-merge';

const MedicationCard: React.FC<{
  medication: MedicationRequestOutputDto[];
  locale: Record<string, string>;
  hideHeader?: boolean;
  className?: string;
  isQuestionnaireMedication?: boolean;
}> = ({
  medication,
  locale,
  hideHeader = false,
  className,
  isQuestionnaireMedication = false,
}) => {
  if (!medication) {
    return null;
  }
  return (
    <div
      data-testid={`medication-${medication[0]?.prescriptionFhirId}`}
      className={twMerge(
        'rounded-10 border border-gray-opacity-15 overflow-hidden',
        className,
      )}
    >
      {!hideHeader && (
        <MedicationHeader
          {...medication[0]}
          locale={locale}
          isQuestionnaireMedication={isQuestionnaireMedication}
        />
      )}
      <div className="gap-2.5 py-4 bg-neutral-100 overflow-hidden hidden desktop:grid grid-cols-12 w-full px-30 text-charcoal-gray text-base font-semibold">
        <div className="col-span-2">{locale?.medication}</div>
        <div className="col-span-2">{locale?.dose || 'Dose'}</div>
        <div className="col-span-2">{locale?.frequency || 'Frequency'}</div>
        <div className="col-span-2">{locale?.duration || 'Duration'}</div>
        <div className="col-span-2">{locale?.takeWith || 'Take with'}</div>
        <div className="col-span-2">{locale?.notes || 'Notes'}</div>
      </div>
      {medication?.map((med) => (
        <React.Fragment key={med.prescriptionFhirId}>
          <MedicationRow {...med} />
          <MedicationMobile medication={med} locale={locale} />
        </React.Fragment>
      ))}
    </div>
  );
};

export default MedicationCard;
